import React from 'react'
import { useViewport, viewportBreakpoint } from '../utils'
import { X } from 'react-feather'
import colors from '../utils/colors'

const TagItem = ({value}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div
      className="border rounded flex items-center justify-between px-2 lg:px-3 py-2"
      style={{borderColor: colors.blue}}
    >
      <p className="leading-none lg:leading-tight text-sm text-gray-444 pr-2 lg:pr-3">{value}</p>
      <X width={isMobile ? 14 : 16} />
    </div>
  )
}

export { TagItem }